<template>

  <div class="OrderDetail">
    <div class="main">

      <div class="title_bar">
        <h1 v-if='company'>{{company.name}}</h1>
      </div>

      <!-- 送迎中のマップビュー -->
      <gmap-map
        id="map"
        ref="map"
        :center="{lat: center.latitude, lng: center.longitude}"
        :zoom="12"
      >
        <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="{lat: m.latitude, lng: m.longitude}"
          :icon="{ url: require('../assets/runner_pin@2x.png'),
          scaledSize: {width: 34, height: 40}
          }"
        ></gmap-marker>

        <gmap-marker
          :key="index + 1000"
          v-for="(m, index) in destinations"
          :position="{lat: m.latitude, lng: m.longitude}"
        ></gmap-marker>
      </gmap-map>


      <div class="driverListTitle">
        Add your runners to your map
      </div>


      <div class="driverListArea">
        <ul class="driverList">
          <li class="driverRow" v-for="driver in drivers" v-bind:key="driver.id">

            <img :src="checkMarkSrc(driver)" :alt=visible_drivers @click="rowClicked(driver)">

            <!--<img v-bind:class="{'hogehoge2': driver.visible === true, 'hogehoge':  driver.visible === false}">-->
            <!--<img v-bind:class="{'hogehoge': driver.visible != null && driver.visible === true, 'hogehoge':  driver.visible == null && driver.visible === false}"/> -->
            <!--<img :class="driver.visible" class="checkmark" v-if="driver.visible" src="../assets/checkbox_not_selected.png" />-->
            <!--<img :key="driver.visible" class="checkmark" v-else src="../assets/checkbox_selected.png" />-->
            <!--<img lass="checkmark" :src="visible_drivers[driver.id] != null ? 'require(../assets/checkbox_selected.png)' : 'require(../assets/checkbox_not_selected.png)'"> -->
            <!--<img v-bind:src="checkMarkImage(driver)" class="checkmark" v-bind:alt="pic"> -->

            {{driver.name}}

          </li>
        </ul>
      </div>

      <div class="footer">
        <div class="footer_logo_helper">
          <img class="footer_logo" src="../assets/ikude_footer_logo.png" alt="ikude">
        </div>
      </div>


    </div>

  </div>

</template>

<script>
  import {db, fb} from '../firebase'
  import moment from 'moment'
  import {Subject, Observable, combineLatest, asyncScheduler, asapScheduler} from 'rxjs'


  export default {

    name: "Run",
    created() {


      console.log('created called')

      //IMPORTATNT: ここでqueryから指定されたドライバーIDををvisible_driversに登録
      let specified_driver_id = this.$route.query.d
      if(specified_driver_id != null){
        this.visible_drivers[specified_driver_id] = true
      }

      var _this = this

      this.mapLoadSubject = new Subject()


      this.$watch('drivers', function (value) {
        console.log('drivers changed, and position updated', value.length)

        _this.updateMarkers(value)

      })
    },
    mounted() {

      console.log('mounted called')



      this.getCompany()
      this.getDrivers()
    },

    updated() {
      let _this = this

      if (this.isMapLoaded === false) {

        // ビュー全体がレンダリングされた後にのみ実行されるコード

        /* マップオブジェクトを取得(mountedでやると、まだthis.$refs.mapがnull */
        if (this.$refs.map != null) {
          console.log("map is not null");

          this.isMapLoaded = true

          this.$refs.map.$mapPromise.then((map) => {

            //TODO: ズームはマラソンの領域にフォーカスするように変更する


            console.log("mapLoadSubject.next()");
            _this.mapLoadSubject.next()
          })
        } else {
          console.log("map is null");
        }
      }

      /*
      this.$nextTick(function () {

      })
      */
    },

    data() {
      return {
        drivers: [],

        //TODO: ベルリン・マラソンのcenterにしておく
        center: {latitude: 45.508, longitude: -73.587},
        markers: [],
        destinations: [],
        company: null,
        visible_drivers: {},


        mapLoadSubject: null,
        subscription: null,

        isMapLoaded: false,




      }
    },


    computed: {



    },

    methods: {

      checkMarkSrc(driver) {
        let itDriver = this.visible_drivers[driver.id]
        if(itDriver && itDriver === true) {
          return require("@/assets/checkbox_selected.png")
        }else{
          return require("@/assets/checkbox_not_selected.png")
        }

        /*
        if(this.testToggle === true) {

          console.log('this.drivers[****]', thisDriver.visible)
          if(this.drivers[0].visible === true) {
            return require("@/assets/checkbox_selected.png")
          }else{
            return require("@/assets/checkbox_not_selected.png")
          }
        }else{
          console.log('this.drivers[*****', thisDriver.visible)
          if(this.drivers[0].visible === true) {
            return require("@/assets/checkbox_selected.png")
          }else{
            return require("@/assets/checkbox_not_selected.png")
          }
        }
        */
      },


      checkMarkImage(driver){

        var images = require.context('../assets/', false, /\.png$/)


        //return "../assets/checkbox_not_selected.png"
        //"visible_drivers[driver.id] != null ? '../assets/checkbox_selected.png' : '../assets/checkbox_not_selected.png'"

        //let dr = this.visible_drivers[driver.id]
        //console.log("visible?", driver)

        //this.pic = !this.pic

        if(this.testToggle === true){
          return images("./checkbox_selected.png")
        }else{
          return images("./checkbox_not_selected.png")
        }

      },

      getDrivers() {
        let self = this

        this.$bind('drivers', db.collection('companies').doc(this.$route.params.company_id).collection('drivers')).then(drivers => {
          console.log("getDrivers done", drivers)

          //IMPORTATNT: ここでqueryから指定されたドライバーIDををvisible_driversに登録
          let specified_driver_id = this.$route.query.d
          if(specified_driver_id != null){

            this.visible_drivers[specified_driver_id] = true

            console.log('Specifiedd.....')


            for (var i = 0; i < this.drivers.length; i++) {

              console.log('specified_driver_id', specified_driver_id)
              let driver = this.drivers[i]
              driver.visible = driver.id === specified_driver_id

              console.log('visible_driver_updated', driver.visible)
            }

          }


        })
      },


      getCompany() {
        this.$bind('company', db.collection('companies').doc(this.$route.params.company_id)).then(company => {
          //this.$unbind('company')

          console.log("getCompany done", company)

          this.center = {
            latitude: company.destination_latitude,
            longitude: company.destination_longitude
          };

          this.destinations = []
          this.destinations.push({
            latitude: company.destination_latitude,
            longitude: company.destination_longitude
          })
        })
      },

      positionTimeString(position_time) {
        if (position_time != null) {
          let date = position_time.toDate()
          return moment(date).format('YYYY/MM/DD HH:mm')
        }
        return ''
      },

      updateMarkers(drivers) {
        console.log("updateMarkers", drivers)
        this.markers = []
        for (let i = 0; i < drivers.length; i++) {
          let driver = drivers[i]

          if (driver.latitude && driver.longitude) {
            //スペシフィックなドライバーが定義されてない場合は全員表示。表示されている場合は、その人だけ表示

            console.log("updateMarkers for ", driver.name)
            if (this.visible_drivers[driver.id] && this.visible_drivers[driver.id] === true) {
              console.log("add marker for the driver", driver.name)
              //In the array!
              this.markers.push(
                {
                  latitude: driver.latitude,
                  longitude: driver.longitude,
                  name: driver.name,
                  driver_id: driver.id,
                  time: this.positionTimeString(driver.position_time),
                }
              )
            }
          }
        }
      },

      //TODO: これはまだ開発中.
      updateBounds(){
        let bounds  = new google.maps.LatLngBounds();
        bounds.extend(new google.maps.LatLng(this.company.destination_latitude, this.company.destination_longitude,));

        // bounds.extend(new google.maps.LatLng(driver.latitude, driver.longitude));
        map.fitBounds(bounds);       //auto-zoom
        map.panToBounds(bounds);       // auto-center
      },

      rowClicked(driver) {

        if(driver.name.endsWith(' ')){
          driver.name = driver.name.substring(0, driver.name.length - 1);
        }else{
          driver.name = driver.name + ' '
        }

        if(this.visible_drivers[driver.id] != null){
          delete this.visible_drivers[driver.id]
        }else{
          this.visible_drivers[driver.id] = true
        }

        this.updateMarkers(this.drivers)

      },
    }


  }
</script>

<style scoped>
  .OrderDetail {
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: #FFFFFF;
  }

  .OrderDetail h1 {
    color: #5C5C5C;
    font-size: 17px;
    font-weight: normal;
    margin: 0 0 0 0;
    background-color: #F3F3F3;
    height: 34px;
    line-height: 34px;
    padding-top: 4px;
  }

  .main {
    width: 100%;
    background-color: #FFFFFF;
  }


  h1, h2 {
    font-weight: normal;
  }

  a {
    color: #42b983;
  }


  .title_bar h1 {
    background-color: #D2FF00;
    color: #5C5C5C;
  }



  .order {
    width: auto;
    height: 100%;
    text-align: center;

    margin-top: 15px;
  }

  .order table {
    color: #5C5C5C;
    font-size: 13px;
    font-weight: lighter;
    margin-left: 4%;
    margin-right: 4%;
  }


  #companyName {
    color: #5C5C5C;
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 0;
  }

  #orderId {
    color: #5C5C5C;
    font-size: 10px;
    font-weight: lighter;
    margin-top: 0;
    margin-bottom: 12px;
  }

  #orderCustomerRow {

  }


  .tableItemName {
    text-align: right;
    vertical-align: top;
    padding-bottom: 2px;
    width: 100px;
  }

  .tableItemValue {
    text-align: left;
    padding-left: 20px;
    padding-bottom: 2px;
    vertical-align: top;
  }

  #destinationAddressRow .tableItemValue {
    padding-bottom: 0;
  }

  #destinationAddressRow .tableItemName {
    padding-bottom: 0;
  }

  #mapTitle {
    color: #5C5C5C;
    font-size: 13px;
    margin-top: 20px;
    margin-bottom: 2px;
  }


  #map {
    width: 100%;
    height: 370px;
  }

  /*
    .footer {
      height: 21px;
      width: 100%;
      background-color: #666666;
      margin-top: 30px;
      padding-bottom: 0;
      margin-bottom: 0;
    }

    .footer_logo_helper {
      width: 50px;
      height: 15px;
      margin-left: auto;
      margin-right: auto;
      vertical-align: top;
      padding-top: 3px;
      padding-bottom: 3px;
    }


    .logo {
      width: 100%;
      height: 500px;

    }
    */


  .footer {
    display: table;
    width: 100%;
    height: 21px;
    margin-left: auto;
    margin-right: auto;
    background-color: #666666;
  }

  .footer_logo_helper {
    display: table-cell;
    width: 100px;
    height: 15px;
    vertical-align: middle;
    padding-top: 3px;
    padding-bottom: 3px;
  }

  .footer_logo{
    width: 50px;
    height: 15px;
    vertical-align: top;
    padding: 0;
    margin: 0;
  }


  #preparingCaution {
    width: 100%;
    height: 600px;
    background: #F2F2F2 url('../assets/img_waiting_bg.png') no-repeat center;
    background-size: cover;
  }

  .preparingCautionIcon {
    width: 36%;
    height: auto;
    margin-top: 40px;
  }


  .orderStatusTitle {
    color: #707070;
    font-size: 22px;
    font-weight: bold;
    padding-top: 44px;
    margin-bottom: 20px;
  }

  .orderStatusDescription {
    color: #707070;
    font-size: 16px;
    font-weight: bold;
    margin-top: 0;
    padding-top: 0;
    margin-bottom: 0;
    padding-bottom: 0;
  }


  .orderCompleted {
    width: auto;
    height: 600px;
    text-align: center;
    margin-top: 15px;
  }




  /* tbodyの外側に枠を引く
  https://stackoverflow.com/a/18990202/1709287
  */
  table{
    display: block;
    width: 95%;
    margin: auto;
    height: 400px;
    overflow-y: scroll;
    border-collapse: collapse;
  }

  tbody {
    border: 2px solid #EEEEEE;
    border-collapse: separate;
    border-spacing: 4px;
    background-color: white;
  }

  /* 各行の下に線を引く
  https://stackoverflow.com/a/10040976/1709287
  */

  .col_1 {
    width: 20%;
  }

  .col_2 {
    width: 80%;
  }


  tr.orderRow td {
    border-bottom: 2px solid #EEEEEE;
    color: #5C5C5C;
    font-weight: lighter;
    font-size: 17px;
    padding: 11px 18px 10px 16px;
  }


  /* Table */
  .driverListTitle {
    color: #5C5C5C;
    font-weight: bold;
    font-size: 16px;
    text-align: left;
    width: 95%;
    margin: 9px auto 0 auto;

  }
  .driverListArea{
    height:280px;
    width:95%;
    margin: 1px auto 40px auto;
    border: 2px solid #EEEEEE;
    border-collapse: separate;
    border-spacing: 4px;

  }

  .driverList{
    text-align: left;
    list-style:none;
    max-height:150px;
    margin:0;
    overflow-y:auto;
    padding:0;
    text-indent:10px;
  }

  .driverRow{
    line-height:22px;
    border-bottom: 2px solid #EEEEEE;
    color: #5C5C5C;
    font-weight: lighter;
    font-size: 16px;
    padding: 4px 4px 4px 10px;
  }



</style>



// WEBPACK FOOTER //
// src/pages/Run.vue